/* Whether the field app runs installed, from the home screen, rather than in a
 * browser tab. It matters for the work on the phone: WebKit can delete the
 * storage of a site left unused, and an installed web app is exempt (`27`
 * section 6). iOS reports an installed app through
 * `navigator.standalone`; every other browser through the manifest's
 * `display: standalone`.
 */
export function installed(w: Pick<Window, "matchMedia" | "navigator">): boolean {
  return w.matchMedia("(display-mode: standalone)").matches || (w.navigator as { standalone?: boolean }).standalone === true;
}
